import React from 'react';
import { formula, additives, product } from '../mock';
import { Sparkles } from 'lucide-react';

export default function Formula() {
  return (
    <section id="science" className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1400px]">
        <div className="pb-10 max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
            <span className="tag-dot" /> The Formula
          </div>
          <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium">
            Three magnesium forms.<br /><span className="font-display italic text-teal">One</span> perfect stack.
          </h2>
          <p className="text-neutral-500 mt-3">
            Most brands use cheap magnesium oxide with only 4% absorption. TriMag layers three premium forms that work at different sites in your body — so nothing gets wasted.
          </p>
        </div>

        <div className="relative rounded-3xl bg-[color:var(--cv-ink)] text-white p-6 sm:p-10 overflow-hidden">
          <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[color:var(--cv-teal)] opacity-15 blur-3xl" />
          <div className="relative grid lg:grid-cols-[1fr_auto] gap-10 items-center">
            <div className="grid md:grid-cols-3 gap-6">
              {formula.map((f, i) => (
                <div key={f.id} className="relative rounded-2xl bg-white/5 border border-white/10 p-5">
                  <div className="flex items-center justify-between">
                    <span className="text-[10px] uppercase tracking-widest text-white/50">Form 0{i+1}</span>
                    <span className="font-mono text-teal text-sm font-semibold">{f.dose}</span>
                  </div>
                  <h4 className="font-grotesk mt-3 text-xl font-semibold leading-tight">{f.name}</h4>
                  <div className="text-teal text-xs mt-1 tracking-widest uppercase">{f.role}</div>
                  <p className="mt-3 text-[13px] text-white/60 leading-relaxed">{f.desc}</p>
                </div>
              ))}
            </div>
            <div className="hidden lg:block w-[220px] h-[300px] product-crop-container">
              <img src={product.image} alt="" className="w-full h-full object-cover product-crop drop-shadow-[0_30px_35px_rgba(31,182,193,0.35)]" />
            </div>
          </div>

          <div className="relative mt-8 pt-6 border-t border-white/10 flex flex-wrap items-center gap-8">
            <div className="inline-flex items-center gap-2 text-white/60 text-sm">
              <Sparkles size={16} className="text-teal" /> Boosted with:
            </div>
            {additives.map((a) => (
              <div key={a.name} className="text-sm">
                <span className="font-semibold">{a.name}</span>
                <span className="text-white/50"> — {a.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
